<template>
	<div class="BuyerAccountUsageRecord">
		<div class="summary_bag">
			<div class="summary_complete_bag">
				<!-- 时间 -->
				<el-form
					:inline="true"
					label-width="120px"
					ref="selectForm"
					:model="selectForm"
				>
					<el-form-item
						label="选择分部门"
						prop="departmentValue"
						v-if="
							UserInfo.system < 3 ||
								UserInfo.superDepartmentName === '客服部' ||
								(UserInfo.system === 5 &&
									UserInfo.superDepartmentName ===
										'常规客服部')
						"
					>
						<el-select
							clearable
							v-model="selectForm.departmentValue"
							placeholder="请选择"
							value-key="rid"
							@change="selectChange($event, 'groupList')"
						>
							<el-option
								v-for="item in departmentList"
								:key="item.rid"
								:label="item.departmentName"
								:value="item"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item
						label="选择组"
						prop="groupValue"
						v-if="
							UserInfo.system < 4 ||
								UserInfo.superDepartmentName === '客服部' ||
								(UserInfo.system === 5 &&
									UserInfo.superDepartmentName ===
										'常规客服部')
						"
					>
						<el-select
							clearable
							v-model="selectForm.groupValue"
							placeholder="请选择"
							value-key="rid"
							@change="selectChange($event, 'staffList')"
						>
							<el-option
								v-for="item in groupList"
								:key="item.rid"
								:label="item.groupName"
								:value="item"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item
						label="选择员工"
						prop="staffValue"
						v-if="
							UserInfo.system < 5 ||
								UserInfo.superDepartmentName === '客服部' ||
								(UserInfo.system === 5 &&
									UserInfo.superDepartmentName ===
										'常规客服部')
						"
					>
						<el-select
							clearable
							v-model="selectForm.staffValue"
							placeholder="请选择"
							value-key="rid"
							@change="selectChange($event)"
						>
							<el-option
								v-for="item in staffList"
								:key="item.rid"
								:label="item.roleUserName"
								:value="item"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="买家账号等级" prop="value">
						<el-select
							clearable
							v-model="selectForm.value"
							placeholder="请选择"
						>
							<el-option
								v-for="(item, index) in List"
								:key="index"
								:label="item.gradeName"
								:value="item.id"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="信用卡账号等级" prop="mark">
						<el-select v-model="selectForm.mark" clearable>
							<el-option
								v-for="(item, index) in List2"
								:key="index"
								:label="item.gradeName"
								:value="item.id"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="买家地址等级" prop="isTranslation">
						<el-select v-model="selectForm.isTranslation" clearable>
							<el-option
								v-for="(item, index) in List3"
								:key="index"
								:label="item.gradeName"
								:value="item.id"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="下单IP地址等级" prop="SingleIPLevel">
						<el-select v-model="selectForm.SingleIPLevel" clearable>
							<el-option
								v-for="(item, index) in List4"
								:key="index"
								:label="item.gradeName"
								:value="item.id"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item clearable label="账号状态" prop="AccountStatus">
						<el-select v-model="selectForm.AccountStatus" clearable>
							<el-option
								v-for="(item, index) in AccountStatus"
								:key="index"
								:label="item.label"
								:value="item.value"
							></el-option>
						</el-select>
					</el-form-item>
					<!-- <el-form-item clearable label="领用状态" prop="RecipientsState">
						<el-select v-model="selectForm.RecipientsState">
							<el-option
								v-for="(item, index) in RecipientsState"
								:key="index"
								:label="item.label"
								:value="item.value"
							></el-option>
						</el-select>
					</el-form-item> -->
					<el-form-item label="买家账号组合方案" prop="combinationPlan">
						<el-select v-model="selectForm.combinationPlan" @change="handleChange" clearable>
							<el-option
								v-for="(item, index) in List5"
								:key="index"
								:label="item.programName"
								:value="item.id"
							></el-option>
						</el-select>
					</el-form-item><br>
                    <el-form-item>
                        <span slot="label">
                            <span class="span-box">
                                <p>国家</p>
                                <el-tooltip style="diaplay:inline" effect="dark" content="此国家为下单账号所属国家，及该国家账号还有多少" placement="top">
                                    <i class="el-icon-question" />
                                </el-tooltip>
                            </span>
                        </span>
						<el-radio-group v-model="selectForm.country">
							<el-row type="flex">
								<el-radio label="US">美国 ( {{ countryList.US }} )</el-radio>
								<el-radio label="CA">加拿大 ( {{ countryList.CA }} )</el-radio>
								<el-radio label="MX">墨西哥 ( {{ countryList.MX }} )</el-radio>
							</el-row>
							<el-row type="flex" style="margin: 10px 0">
								<el-radio label="GB">英国 ( {{ countryList.GB }} )</el-radio>
								<el-radio label="DE">德国 ( {{ countryList.DE }} )</el-radio>
								<el-radio label="FR">法国 ( {{ countryList.FR }} )</el-radio>
								<el-radio label="IT">意大利 ( {{ countryList.IT }} )</el-radio>
								<el-radio label="ES">西班牙 ( {{ countryList.ES }} )</el-radio>
								<el-radio label="NL">荷兰 ( {{ countryList.NL }} )</el-radio>
								<el-radio label="SE">瑞典 ( {{ countryList.SE }} )</el-radio>
								<el-radio label="PL">波兰 ( {{ countryList.PL }} )</el-radio>
								<el-radio label="SA">沙特阿拉伯 ( {{ countryList.SA }} )</el-radio>
								<el-radio label="AE">阿联酋 ( {{ countryList.AE }} )</el-radio>
							</el-row>
							<el-row type="flex">
								<el-radio label="JP">日本 ( {{ countryList.JP }} )</el-radio>
								<el-radio label="AU">澳大利亚 ( {{ countryList.AU }} )</el-radio>
								<el-radio label="SG">新加坡 ( {{ countryList.SG }} )</el-radio>
							</el-row>
							<!-- <el-radio v-for="(item,index) in country" :key="index" :label="item.value">{{item.name}}</el-radio> -->
						</el-radio-group>
                    </el-form-item><br>
					<el-form-item label="时间筛选类型" prop="isTranslation">
						<el-radio-group v-model="selectForm.timeType">
                            <el-radio :label="1">申请时间</el-radio>
                            <el-radio :label="2">审核时间</el-radio>
                            <el-radio :label="3">回收时间</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="开始日期" prop="startTime">
						<el-date-picker
							v-model="selectForm.startTime"
							align="right"
							type="datetime"
							:picker-options="pickerOptions"
							placeholder="选择开始日期"
							value-format="yyyy-MM-dd HH:mm:ss"
							style="width:200px;"
						></el-date-picker>
					</el-form-item>
					<el-form-item label="结束日期" prop="endTime">
						<el-date-picker
							v-model="selectForm.endTime"
							align="right"
							type="datetime"
							:picker-options="pickerOptions"
							placeholder="选择结束日期"
							value-format="yyyy-MM-dd HH:mm:ss"
							style="width:200px;"
						></el-date-picker>
					</el-form-item>
					<el-form-item label=" " prop="input">
						<el-input
							class="custom-input"
							v-model="selectForm.input"
							placeholder="全字段搜索"
							style="width:258px;"
							clearable
						></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary"
							@click="Search"
							>搜索</el-button
						>
						<el-button
							@click="searchReset"
							type="primary"
							>重置</el-button
						>
					</el-form-item>
					<!-- </div> -->
				</el-form>
			</div>
			<!-- 买家账号审批流程设置-->
			<!-- <div class="summary_pagenum">
                <el-button type="primary" @click="edit1">标记账号状态</el-button>
                <el-select v-model="MarkAccountStatus" placeholder="待回收、已封禁" style="margin-left: 5px">
                    <el-option
                        v-for="(item, index) in options"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                    ></el-option>
                </el-select>
			</div> -->
			<div class="summary_content">
				<div class="summary_list">
					<!-- 头部 -->
					<el-table
						:data="summarylist"
						style="width: 100%"
						v-loading="load_data"
						element-loading-text="拼命加载中"
						border
						:header-cell-style="iscenter"
						stripe
					>
						<el-table-column
							label="序号"
							prop="id"
							align="center"
							width="50"
						></el-table-column>
						<el-table-column
							label="买家账号组合方案"
							align="center"
							prop="buyerAccountCombination.programName"
						>
						</el-table-column>
						<el-table-column
							prop="buyerAccountInformation.gradeName"
							label="买家账号等级"
							align="center">
						</el-table-column>
						<el-table-column
							prop="creditCardAccountInformation.gradeName"
							label="信用卡账号等级"
							align="center"
						></el-table-column>
						<el-table-column
							prop="buyerAddressInformation.gradeName"
							label="买家地址等级"
							align="center"
						></el-table-column>
						<el-table-column
							prop="orderIPAddressInformation.gradeName"
							label="下单IP地址等级"
							align="center"
						>
						</el-table-column>
						<el-table-column
							label="账号状态"
							align="center"
							width="80"
						>
							<template slot-scope="scope">
								<p v-if="scope.row.buyerAccountInformation.buyerAccountAccountStatus == 1" style="color:green">活跃中</p>
								<p v-else-if="scope.row.buyerAccountInformation.buyerAccountAccountStatus == 0" style="color:red">已封禁</p>
								<p v-else-if="scope.row.buyerAccountInformation.buyerAccountAccountStatus == 2" style="color:#feba07">待回收</p>
								<p v-else-if="scope.row.buyerAccountInformation.buyerAccountAccountStatus == 3">已回收</p>
							</template>
						</el-table-column>
						<!-- <el-table-column
							prop="buyerAccountInformation.buyerAccountRequisitionStatus"
							label="领用状态"
							align="center"
						>
							<template slot-scope="scope">
								<p v-if="scope.row.buyerAccountInformation.buyerAccountRequisitionStatus == 1">已领用</p>
								<p v-else-if="scope.row.buyerAccountInformation.buyerAccountRequisitionStatus == 0" style="color:#feba07">未领用</p>
							</template>
						</el-table-column> -->
						<el-table-column
							label="国家"
							align="center"
							width="100"
							prop="buyerAccountInformation.country"
						>
						</el-table-column>
						<el-table-column
							prop="roleName"
							label="使用人"
							align="center"
						>
						</el-table-column>
						<el-table-column
							prop="applicationTime"
							label="申请时间"
							align="center"
						>
						</el-table-column>
						<el-table-column
							prop="createTime"
							label="审批时间"
							align="center"
						>
						</el-table-column>
						<el-table-column
							prop="buyerAccountInformation.recoveryTime"
							label="回收时间"
							align="center"
						>
						</el-table-column>
						<el-table-column
							label="操作"
							align="center"
						>
                            <template slot-scope="scope">
                                <el-button type="primary" @click="edit(scope.row)">详情</el-button>
                            </template>
						</el-table-column>
					</el-table>
				</div>
			</div>
			<div class="summary_pagenum_block">
				<div class="block">
                    <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page="page"
					    :page-size="size"
                        @size-change="handleSizeChange"
                        :page-sizes="[10, 20, 50, 100]"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                    ></el-pagination>
				</div>
			</div>
		</div>  
        <el-dialog :visible.sync="EditReimbursement" width="52%">
            <div slot="title">
                <el-row type="flex" justify="space-between" align="middle">
                    <p style="font-size:17px;color:#303133">买家账号组合方案</p>
                    <p style="font-size:14px;color:#303133;margin-right:40px" v-if="applyTime">申请时间：{{ applyTime }}</p>
                </el-row>
            </div>
            <el-form :model="form" class="form" v-if="UserInfo.system === 1 || form.buyerAccountAccountStatus != 3">
                <el-row type="flex">
                    <el-form-item label="买家账号等级" :label-width="formLabelWidth">
                        <el-select v-model="form.gradeName" disabled clearable>
                            <el-option
                                v-for="(item, index) in List"
                                :key="index"
                                :label="item.gradeName"
                                :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="收费标准" :label-width="formLabelWidth">
                        <el-input v-model="form.charge" disabled></el-input>
                        元/条
                    </el-form-item>
                </el-row>
                <el-form-item label="国家" :label-width="formLabelWidth">
                    <el-select v-model="form.country" disabled clearable>
                        <el-option
                            v-for="(item, index) in country"
                            :key="index"
                            :label="item.name"
                            :value="item.Referred"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-row type="flex">
                    <el-form-item label="买家账号" :label-width="formLabelWidth">
                        <el-input v-model="form.buyerAccount" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱密码" :label-width="formLabelWidth">
                        <el-input v-model="form.emailPassword" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="辅助邮箱" :label-width="formLabelWidth">
                        <el-input v-model="form.recoveryEmail" disabled></el-input>
                    </el-form-item>
                </el-row>
                <el-row type="flex">
                    <el-form-item label="买家名称" :label-width="formLabelWidth">
                        <el-input v-model="form.buyerName" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="注册时间" :label-width="formLabelWidth">
                        <el-date-picker
							disabled
                            v-model="form.createTime"
                            type="datetime"
                            placeholder="选择注册时间">
						</el-date-picker>
                    </el-form-item>
                </el-row>
				<el-row type="flex">
					<el-form-item label=" " :label-width="formLabelWidth">
						<el-dropdown trigger="click" @command="handleCommand($event,'1')">
							<el-button type="primary">
								标记账号状态<i class="el-icon-arrow-down el-icon--right"></i>
							</el-button>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item command="2">待回收</el-dropdown-item>
								<el-dropdown-item command="0">已封禁</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</el-form-item>
					<el-form-item label="账号状态：" label-width="166px">
						<p v-if="form.buyerAccountAccountStatus === 1" style="color:green">活跃中</p>
						<p v-else-if="form.buyerAccountAccountStatus === 0" style="color:red">已封禁</p>
						<p v-else-if="form.buyerAccountAccountStatus === 2" style="color:#feba07">待回收</p>
						<p v-else-if="form.buyerAccountAccountStatus === 3">已回收</p>
					</el-form-item>
				</el-row>
            </el-form>
            <el-form :model="form1" class="form" v-if="UserInfo.system === 1 || form1.creditCardAccountStatus != 3">
                <el-row type="flex">
                    <el-form-item label="信用卡账号等级" :label-width="formLabelWidth">
                        <el-select v-model="form1.gradeName" disabled clearable>
                            <el-option
                                v-for="(item, index) in List2"
                                :key="index"
                                :label="item.gradeName"
                                :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="收费标准" :label-width="formLabelWidth">
                        <el-input v-model="form1.charge" disabled></el-input>
                        元/条
                    </el-form-item>
                </el-row>
                <el-form-item label="国家" :label-width="formLabelWidth">
                    <el-select v-model="form1.country" disabled clearable>
                        <el-option
                            v-for="(item, index) in country"
                            :key="index"
                            :label="item.name"
                            :value="item.Referred"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-row type="flex">
                    <el-form-item label="信用卡账号" :label-width="formLabelWidth">
                        <el-input v-model="form1.creditCardAccount" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="有效期" :label-width="formLabelWidth">
                        <el-date-picker
							disabled
                            v-model="form1.expirationDate"
							format="yyyy-MM-dd"
                            type="datetime"
                            placeholder="选择有效时间">
						</el-date-picker>
                    </el-form-item>
                </el-row>
                <el-form-item label="安全码" :label-width="formLabelWidth">
                    <el-input v-model="form1.creditCardReceiptStatus" disabled></el-input>
                </el-form-item>
				<el-row type="flex">
					<el-form-item label=" " :label-width="formLabelWidth">
						<el-dropdown trigger="click" @command="handleCommand($event,'2')">
							<el-button type="primary">
								标记账号状态<i class="el-icon-arrow-down el-icon--right"></i>
							</el-button>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item command="2">待回收</el-dropdown-item>
								<el-dropdown-item command="0">已封禁</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</el-form-item>
					<el-form-item label="账号状态：" label-width="166px">
						<p v-if="form1.creditCardAccountStatus === 1" style="color:green">活跃中</p>
						<p v-else-if="form1.creditCardAccountStatus === 0" style="color:red">已封禁</p>
						<p v-else-if="form1.creditCardAccountStatus === 2" style="color:#feba07">待回收</p>
						<p v-else-if="form1.creditCardAccountStatus === 3">已回收</p>
					</el-form-item>
				</el-row>
            </el-form>
            <el-form :model="form2" class="form" v-if="UserInfo.system === 1 || form2.buyerAddressAccountStatus != 3">
                <el-row type="flex">
                    <el-form-item label="买家地址等级" :label-width="formLabelWidth">
                        <el-select v-model="form2.gradeName" disabled clearable>
                            <el-option
                                v-for="(item, index) in List3"
                                :key="index"
                                :label="item.gradeName"
                                :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="收费标准" :label-width="formLabelWidth">
                        <el-input v-model="form2.charge" disabled></el-input>
                        元/条
                    </el-form-item>
                </el-row>
                <el-row type="flex">
                    <el-form-item label="国家" :label-width="formLabelWidth">
                        <el-select v-model="form2.country" disabled clearable>
                            <el-option
                                v-for="(item, index) in options"
                                :key="index"
                                :label="item.name"
                                :value="item.Referred"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="洲/省" label-width="50px">
                        <el-input v-model="form2.stateOrRegion" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="城市" label-width="50px">
                        <el-input v-model="form2.municipality" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="县" label-width="40px">
                        <el-input v-model="form2.county" disabled></el-input>
                    </el-form-item>
                </el-row>
                <el-row type="flex">
                    <el-form-item label="收件人" :label-width="formLabelWidth">
                        <el-input v-model="form2.recipient" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="邮编" label-width="50px">
                        <el-input v-model="form2.postalCode" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="电话" label-width="50px">
                        <el-input v-model="form2.phone" disabled></el-input>
                    </el-form-item>
                </el-row>
                <el-form-item label="地址1" :label-width="formLabelWidth">
                    <el-input v-model="form2.addressLine1" disabled style="width:74%"></el-input>
                </el-form-item>
                <el-form-item label="地址2" :label-width="formLabelWidth">
                    <el-input v-model="form2.addressLine2" disabled style="width:74%"></el-input>
                </el-form-item>
                <el-form-item label="地址3" :label-width="formLabelWidth">
                    <el-input v-model="form2.addressLine3" disabled style="width:74%"></el-input>
                </el-form-item>
				<el-row type="flex">
					<el-form-item label=" " :label-width="formLabelWidth">
						<el-dropdown trigger="click" @command="handleCommand($event,'3')">
							<el-button type="primary">
								标记账号状态<i class="el-icon-arrow-down el-icon--right"></i>
							</el-button>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item command="2">待回收</el-dropdown-item>
								<el-dropdown-item command="0">已封禁</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</el-form-item>
					<el-form-item label="账号状态：" label-width="166px">
						<p v-if="form2.buyerAddressAccountStatus === 1" style="color:green">活跃中</p>
						<p v-else-if="form2.buyerAddressAccountStatus === 0" style="color:red">已封禁</p>
						<p v-else-if="form2.buyerAddressAccountStatus === 2" style="color:#feba07">待回收</p>
						<p v-else-if="form2.buyerAddressAccountStatus === 3">已回收</p>
					</el-form-item>
				</el-row>
            </el-form>
            <el-form :model="form3" class="form" v-if="UserInfo.system === 1 || form3.orderIPAccountStatus != 3">
                <el-row type="flex">
                    <el-form-item label="下单IP地址等级" :label-width="formLabelWidth">
                        <el-select v-model="form3.gradeName" disabled clearable>
                            <el-option
                                v-for="(item, index) in List4"
                                :key="index"
                                :label="item.gradeName"
                                :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="收费标准" :label-width="formLabelWidth">
                        <el-input v-model="form3.charge" disabled></el-input>
                        元/条
                    </el-form-item>
                </el-row>
                <el-form-item label="国家" :label-width="formLabelWidth">
                    <el-select v-model="form3.country" disabled clearable>
                        <el-option
                            v-for="(item, index) in options"
                            :key="index"
                            :label="item.name"
                            :value="item.Referred"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-row type="flex">
                    <el-form-item label="服务器种类" :label-width="formLabelWidth">
						<el-input v-model="form3.serverType" disabled></el-input>
						<!-- <el-select v-model="form3.serverType" disabled>
							<el-option
							v-for="item in options"
							:key="item.value"
							:label="item.label"
							:value="item.value">
							</el-option>
						</el-select> -->
                    </el-form-item>
                    <el-form-item label="购买账号" :label-width="formLabelWidth">
                        <el-input v-model="form3.purchaseAccount" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="购买密码" :label-width="formLabelWidth">
                        <el-input v-model="form3.purchasePassword" disabled></el-input>
                    </el-form-item>
                </el-row>
                <el-row type="flex">
                    <el-form-item label="到期时间" :label-width="formLabelWidth">
                        <el-date-picker
							disabled
                            v-model="form3.expirationDate"
                            type="datetime"
                            placeholder="选择到期时间">
						</el-date-picker>
                    </el-form-item>
                    <el-form-item label="IP地址" :label-width="formLabelWidth">
                        <el-input v-model="form3.address" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="IP密码" :label-width="formLabelWidth">
                        <el-input v-model="form3.password" disabled></el-input>
                    </el-form-item>
                </el-row>
				<el-row type="flex">
					<el-form-item label=" " :label-width="formLabelWidth">
						<el-dropdown trigger="click" @command="handleCommand($event,'4')">
							<el-button type="primary">
								标记账号状态<i class="el-icon-arrow-down el-icon--right"></i>
							</el-button>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item command="2">待回收</el-dropdown-item>
								<el-dropdown-item command="0">已封禁</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</el-form-item>
					<el-form-item label="账号状态：" label-width="166px">
						<p v-if="form3.orderIPAccountStatus === 1" style="color:green">活跃中</p>
						<p v-else-if="form3.orderIPAccountStatus === 0" style="color:red">已封禁</p>
						<p v-else-if="form3.orderIPAccountStatus === 2" style="color:#feba07">待回收</p>
						<p v-else-if="form3.orderIPAccountStatus === 3">已回收</p>
					</el-form-item>
				</el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <!-- <p>合计费用：111元</p> -->
                <el-button @click="EditReimbursement = false">关闭</el-button>
            </div>
        </el-dialog>
	</div>
</template>

<script>
import { ajaxPost, Baseurl } from '../../../api/api/api'
export default {
	name: 'BuyerAccountUsageRecord',
	data() {
		return {
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() > Date.now()
				},
				shortcuts: [
					{
						text: '本月',
						onClick: (picker) => {
							const date = new Date()
							picker.$emit('pick', date)
							this.calculationDate()
						},
					},
					{
						text: '上一月',
						onClick: (picker) => {
							const date = new Date()
							picker.$emit('pick', date)
							this.calculationDate(-1)
						},
					},
					{
						text: '上两月',
						onClick: (picker) => {
							const date = new Date()
							picker.$emit('pick', date)
							this.calculationDate(-2)
						},
					},
					{
						text: '上三月',
						onClick: (picker) => {
							const date = new Date()
							picker.$emit('pick', date)
							this.calculationDate(-3)
						},
					},
				],
			},
            form: '',
			form1: '',
			form2: '',
			form3: '',
			companyId: '',
            MarkAccountStatus: '',
			page: 1,
			size: 20,
			total: 0,
            formLabelWidth: "110px",
			iscenter: {
				textAlign: 'center',
				background: '#f8f8f8',
				color: '#232323',
			},
            EditReimbursement: false,
			load_data: false,
			UserInfo: {},
            summarylist: [],
			selectForm: {
                timeType: '',
				value: '',
				startTime: '',
				endTime: '',
				input: '',
				departmentValue: {},
				groupValue: {},
				staffValue: {},
				mark: '',
				isTranslation: '',
				SingleIPLevel: '',
				AccountStatus: '',
				RecipientsState: '',
				combinationPlan: '',
				country: ''
			},
			List: [],
			List2: [],
			List3: [],
			List4: [],
			List5: [],
			applyTime: '',
            departmentList: [],
            groupList: [],
            options: [],
            staffList: [],
			countryList: {},
            AccountStatus: [
                // { value: 0, label: '全部' },
                { value: 1, label: '活跃中' },
                { value: 0, label: '已封禁' },
                { value: 2, label: '待回收' },
                { value: 3, label: '已回收' },

            ],
            RecipientsState: [
                // { value: 0, label: '全部' },
                { value: 1, label: '已领用' },
                { value: 0, label: '未领用' },
            ],
            country: [
                { value: 0, name: '美国', Referred: 'US' },
                { value: 1, name: '加拿大', Referred: 'CA' },
                { value: 2, name: '墨西哥', Referred: 'MX' },
                { value: 3, name: '英国', Referred: 'GB' },
                { value: 4, name: '德国', Referred: 'DE' },
                { value: 5, name: '法国', Referred: 'FR' },
                { value: 6, name: '意大利', Referred: 'IT' },
                { value: 7, name: '西班牙', Referred: 'ES' },
                { value: 8, name: '荷兰', Referred: 'NL' },
                { value: 9, name: '瑞典', Referred: 'SE' },
                { value: 10, name: '波兰', Referred: 'PL' },
                { value: 11, name: '沙特阿拉伯', Referred: 'SA' },
                { value: 12, name: '阿联酋', Referred: 'AE' },
                { value: 13, name: '日本', Referred: 'JP' },
                { value: 14, name: '澳大利亚', Referred:'AU' },
                { value: 15, name: '新加坡', Referred: 'SG' }

            ]
		}
	},
	created() {
        this.UserInfo = JSON.parse(localStorage.getItem('role'))
		this.init()
		this.selectSettings()
		this.selectSettings1()
		this.getUsageRecordList()
		this.AccountNumber()
		if (
			this.UserInfo.system !== 5 &&
			this.UserInfo.superDepartmentName !== '运营部'
		) {
			this.operateWidth = 80
		}
	},
	methods: {
		handleChange() {
			this.AccountNumber()
		},
		//  查询各国买家账号数量
		AccountNumber() {
			const API = Baseurl + 'companyBuyerInfoController/selectCompanyBuyerInfoCountByRid'
			const paramsData = {
				companyId: this.companyId,
				buyerAccountCombinationId: this.selectForm.combinationPlan,
				rid: this.staffId
			}
			ajaxPost(API,paramsData)
				.then((res) => {
					if(res.data.code === 200) {
						this.countryList = res.data.data
					}else {
						this.$message.error(res.data.data)
					}
				})
		},
		handleCommand(val,value) {
			if(value === '1'){
				const API =  Baseurl + 'buyerAccountController/markBuyerAccount'
				const paramsData = {
					id: this.form.id,       
					style: value,
					buyerAccountAccountStatus: val,
				}
				ajaxPost(API,paramsData)
					.then((res) => {
						if( res.data.code === 200 ){
							this.$message.success('账号状态标记成功')
						}else {
							this.$message.error(res.data.data)
						}
					})
			}else if(value === '2') {
				const API =  Baseurl + 'buyerAccountController/markBuyerAccount'
				const paramsData = {
					id: this.form1.id,       
					style: value,
					creditCardAccountStatus: val,
				}
				ajaxPost(API,paramsData)
					.then((res) => {
						if( res.data.code === 200 ){
							this.$message.success('账号状态标记成功')
						}else {
							this.$message.error(res.data.data)
						}
					})
			}else if(value === '3') {
				const API =  Baseurl + 'buyerAccountController/markBuyerAccount'
				const paramsData = {
					id: this.form2.id,       
					style: value,
					buyerAddressAccountStatus: val,
				}
				ajaxPost(API,paramsData)
					.then((res) => {
						if( res.data.code === 200 ){
							this.$message.success('账号状态标记成功')
						}else {
							this.$message.error(res.data.data)
						}
					})
			}else if(value === '4') {
				const API =  Baseurl + 'buyerAccountController/markBuyerAccount'
				const paramsData = {
					id: this.form3.id,       
					style: value,
					orderIPAccountStatus: val,
				}
				ajaxPost(API,paramsData)
					.then((res) => {
						if( res.data.code === 200 ){
							this.$message.success('账号状态标记成功')
						}else {
							this.$message.error(res.data.data)
						}
					})
			}
		},
		Search() {
			this.getUsageRecordList()
		},
		getUsageRecordList() {
			this.load_data = true;
            const API =  Baseurl + 'companyBuyerInfoController/selectCompanyBuyerInfoUsageRecord'
            const paramsData = {
				companyId: this.companyId,
				buyerAccountCombinationId: this.selectForm.combinationPlan,
				rid: this.staffId,       
				page: this.page,
				size: this.size,
				buyerAccountRankId: this.selectForm.value,
				creditCardRankId: this.selectForm.mark,
				buyerAddressRankId: this.selectForm.isTranslation,
				orderIPAddressRankId: this.selectForm.SingleIPLevel,
				buyerAccountAccountStatus: this.selectForm.AccountStatus,
				countryCode: this.selectForm.country,
				timeType: this.selectForm.timeType,
                beginDate: this.selectForm.startTime,
				endDate: this.selectForm.endTime,
				searchString: this.selectForm.input,
            }
            ajaxPost(API,paramsData)
                .then((res) => {
					this.load_data = false
                    if( res.data.code === 200 ) {
						this.summarylist = res.data.data.list
						this.total = res.data.data.total
                    }else {
						this.$message.error(res.data.data)
					}
                })
		},
		selectSettings() {
			const API =  Baseurl + 'buyerAccountSettingController/selectBuyerAccountSettings'
			const paramsData = {
				companyId: 1                                       // 公司id
			}
			ajaxPost(API,paramsData)
				.then((res) => {
					if( res.data.code === 200 ) {
						this.List = res.data.data.buyerAccountSetting
						this.List2 = res.data.data.creditCardSetting
						this.List3 = res.data.data.buyerAddress
						this.List4 = res.data.data.orderIPAddressSetting
					}else {
						this.$message.error(res.data.data)
					}
				})
		},
		selectSettings1() {
			const API =  Baseurl + 'buyerAccountCombinationController/selectBuyerAccountCombinations'
			const paramsData = {      
				companyId: this.companyId                                         // 公司id
			}
			ajaxPost(API,paramsData)
				.then((res) => {
					if( res.data.code === 200 ) {
						this.List5 = res.data.data
					}else {
						this.$message.error(res.data.data)
					}
				})
		},
		init() {
			const {
				rid,
				system,
				company_id: companyId,
				type: companyType,
				superDepartmentName,
			} = this.UserInfo
			this.companyId = companyId
			this.staffId = rid
			let type = ''
			if (companyType === 1) {
				type = 'branchCompany'
				if (
					superDepartmentName === '客服部' ||
					superDepartmentName === '常规客服部'
				) {
					type = 'sonCompany'
				}
			} else if (companyType === 2) {
				type = 'sonCompany'
			} else if (system < 3) {
				type = 'departmentList'
			} else if (system === 3) {
				type = 'groupList'
			} else if (system === 4) {
				type = 'staffList'
			} else {
				return
			}
			this.getNextPower(rid, system, type)
		},
		getNextPower(rid, system, type) {
			const API = Baseurl + 'roleController/selectNextInfoByRid'
			const paramsData = { rid, system, companyId: this.companyId }
			ajaxPost(API,paramsData)
				.then((res) => {
					const {
						data: { code, data },
					} = res
					if( code === 200 ){
						this[type] = data.next
					}
				})
				.catch((e) => {

				})
		},
		selectChange(event, type) {
			const { rid, system, company_id: companyId } = event
			companyId && (this.companyId = companyId)
			this.getNextPower(rid, system, type)
			if (type === 'sonCompany') {
				this.selectForm.sonCompany = {}
				this.selectForm.departmentValue = {}
				this.selectForm.groupValue = {}
				this.selectForm.staffValue = {}
				this.sonCompany = []
				this.departmentList = []
				this.groupList = []
				this.staffList = []
			} else if (type === 'departmentList') {
				this.selectForm.departmentValue = {}
				this.selectForm.groupValue = {}
				this.selectForm.staffValue = {}
				this.departmentList = []
				this.groupList = []
				this.staffList = []
			} else if (type === 'groupList') {
				this.selectForm.groupValue = {}
				this.selectForm.staffValue = {}
				this.groupList = []
				this.staffList = []
			} else if (type === 'staffList') {
				this.selectForm.staffValue = {}
				this.staffList = []
			}
			this.staffId = rid
		},
		searchReset() {
			this.selectForm.timeType = ''
			this.selectForm.value = ''
			this.selectForm.startTime = ''
			this.selectForm.endTime = ''
			this.selectForm.input = ''
			this.selectForm.departmentValue = ''
			this.selectForm.groupValue = ''
			this.selectForm.staffValue = ''
			this.selectForm.mark = ''
			this.selectForm.isTranslation = ''
			this.selectForm.SingleIPLevel = ''
			this.selectForm.AccountStatus = ''
			this.selectForm.RecipientsState = ''
			this.selectForm.combinationPlan = ''
			this.selectForm.country = ''

			this.getUsageRecordList()
			this.AccountNumber()
		},
        edit(val) {
			this.form = val.buyerAccountInformation
			this.form1 = val.creditCardAccountInformation
			this.form2 = val.buyerAddressInformation
			this.form3 = val.orderIPAddressInformation
            this.EditReimbursement = true;
			this.applyTime = val.applicationTime
        },
        handleSizeChange(val) {
			this.size = val
			this.getUsageRecordList()
		},
		handleCurrentChange(val) {
			this.currentPage4 = val
			this.getUsageRecordList()
		}
	},
}
</script>

<style lang="scss" scoped>
.BuyerAccountUsageRecord {
	width: 98%;
	// background: #F7F7F7;
	padding-bottom: 72px;
	.summary_bag {
		width: 98%;
		margin: auto;
		.summary_complete_bag {
			overflow: hidden;
            .span-box{
                display: flex;
                margin-top: 15px;
                align-items: center;
                justify-content: flex-end;
                .el-icon-question{
                    font-size: 14px;
                }
            }
		}
		.summary_pagenum {
			width: 99.2%;
			margin-bottom: 10px;
			overflow: hidden;
			background: #f5f5f5;
            display: flex;
            padding: 8px;
		}
		.summary_content {
			width: 100%;
			border: 1px solid #eee;
			overflow: hidden;
		}
		.summary_pagenum_block {
			width: 1790px;
			padding: 20px;
			position: fixed;
			right: 0;
			bottom: 0;
			background: #fff;
			z-index: 999;
			.el-pagination {
				display: flex;
				justify-content: center;
			}
		}
	}
    .form{
        border: 1px solid #DCDFE6;
        padding: 10px 0;
        margin-bottom: 15px;
        .el-input{
            width: 180px;
        }
        .el-form-item {
            margin-bottom: 0.2vw;
        }
    }
    .dialog-footer{
        display: flex;
        justify-content: flex-end;
    }
}
</style>